// require custom-event-polyfill to use CustomEvent for older browsers. see: https://www.npmjs.com/package/custom-event-polyfill
require('custom-event-polyfill');

// require lodash
window._ = require('lodash');

// do requests with window.xhrRequest, based on axios
require('./Libraries/XhrRequest');

// dataswitch for switching between mock and real data
require('./Libraries/PeriodOfTimeToggle');

// dataswitch for switching between mock and real data
require('./Libraries/DataSwitch');

// Powerswitch for switching between mock and real data
require('./Libraries/Powerswitch');

// dataswitch for switching between mock and real data
require('./Libraries/TimeTraveler');

// dataswitch for manipulating the entraId used for middleware API calls
require('./Libraries/EntraIdTraveler');

// tooltips
require('./Libraries/Tooltip');

// import router and make it globally available via window.tncpRouter
import Router from './Classes/Events/Router';
window.tncpRouter = new Router();
